// extracted by mini-css-extract-plugin
export default {"zoomModal":"q1-z"};